<!--  ############### Top Select Month Start ################# -->
<div class="select_month_section">
	<section class="row">
		
		<div class="col-auto co_name">
			<h2>{{"CompanyName" | translate}}:</h2>
			<p>{{userName}}</p>
		</div>
		<div class="summary col-auto gap-2">
			<div class="download_dropdown">
				<!-- <a href="download-attendance-summary/{{timeSheetDate}}"><button class="btn btn-primary btn-sm"><i class="bi bi-download"></i> {{"Home.Download" | translate}}</button></a> -->
				<!-- <ul>
					<li><a href="download-attendance-summary">{{"Home.DwnMainMenu" | translate}}</a> </li>
					<li><a href="download-contract-details">{{"Home.DwnContractList" | translate}}</a> </li>
				</ul> -->
			</div>
			
			
		</div>
		</section>
</div>
<!--  ############### Top Select Month End ################# -->
<!--  ############### Middle Containt Area Start ################# -->
<div class="container_wrapper">

	<div class="filter_options mb-3">
		<div class="row align-items-center">
			<div><h3>{{"Filters" | translate}}</h3></div>
			<div class="float_end"><span class="result_count">{{"ResultCnt" | translate}}: {{totalCount}}</span></div>
		</div>
		
		<div class="row align-items-end">
			<!-- <div class="mb-3">
				<label class="col-form-label">{{"SupplierDepartment" | translate}}:</label>
				<select 
                class="form-select" 
                [(ngModel)]="selectedBranch"
                aria-label="Month selection">
                    <option value="-1"> {{"All" | translate}}</option>
                    <option *ngFor="let branch of branchDropdown" [value]="branch.branchId">
                        {{branch.branchName}}
                    </option>
                </select>
			</div> -->
			<div class="mb-3">
				<label class="col-form-label">{{"Company" | translate}}:</label>
				<select 
                class="form-select" 
                [(ngModel)]="selectedCustomer"
                aria-label="Month selection">
                    <option value="-1"> {{"All" | translate}}</option>
                    <option *ngFor="let customer of customerDropdown" [value]="customer.customerID">
                        {{customer.customerName}}
                    </option>
                </select>
			</div>
			<!-- <div class="mb-3">
				<label class="col-form-label">{{"SelectService" | translate}}:</label>
				<select class="form-select" id="" name="">
					<option value="0" selected>{{"All" | translate}}</option>
				</select>
			</div> -->
			<div class="mb-3">
				<label class="col-form-label">{{"SELECTMONTH" | translate}}:</label>
				<select 
                class="form-select" 
                aria-label="Month selection"
                [(ngModel)]="selectedDate">
                    <option *ngFor="let date of monthDropdown" [value]="date.dayDate">
                        <!-- {{ "DDMONTH."+getMonth(date) | translate}} {{getYear(date)}} -->
                          {{(lang == 'en') ? date.eNdate: date.jPdate}}
                    </option>
                </select>
			</div>
			<!-- <div class="mb-3">
				<label class="col-form-label">Selected month:</label>
				<select class="form-select" id="" name="">
					<option value="1" selected>Jan</option>
					<option value="2">Feb</option>
				</select>
			</div> -->
			<div class="mb-3">
				<button type="button" class="btn btn-primary" (click)="onSearch()">{{"Search" | translate}}</button>
				<button type="button" class="btn btn-primary" (click)="clearAll()">{{"ClearAll" | translate}}</button>
			</div>
		</div>
	</div>
	
	<!--  ############### Data Table Start ################# -->
	<div class="client_associate_list p_table" >

        <p-table 
        #dt1
        [value]="companiesList" [tableStyle]="{'width':'100%'}" 
        [paginator]="true"
        [rows]="10"
        [showCurrentPageReport]="true"
        [globalFilterFields]="['comSearchText']"
        currentPageReportTemplate="{{'Showing' |translate}} {first} {{'to' | translate}} {last} {{'of' | translate}} {totalRecords} {{'entries' | translate}}"
        (onFilter)="onFilter($event)"
        (onPage)="onPage($event)" *ngIf="!displayByCompany">
        <!-- (onSort)="onSort()" -->
        <!-- <table class="display nowrap table table-striped" style="width:100%"> -->
            <ng-template #caption>
                
                    <p-iconfield iconPosition="left" class="ml-auto">                        
                        <label>{{"SearchByText" | translate}}:</label>
                        <input pInputText type="text" (input)="applyFilterGlobal($event)" placeholder="{{'SearchKey' | translate}}" />
                    </p-iconfield>
                
            </ng-template>
            <ng-template pTemplate="header">                
                <!-- <thead> -->
                    <tr class="tbl_head">
                        <th rowspan="2" class="bor_lft_none">{{"AssociatesList.Company" | translate}}</th>
                        <th rowspan="2">{{"Section" | translate}}</th>
                        <th colspan="4">{{"AssociatesList.TWH" | translate}}</th>
                        <th colspan="4">{{"AssociatesList.STATUS" | translate}}</th>
                        <th colspan="3">{{"AssociatesList.Summary" | translate}}</th>
                        <th rowspan="2" class="min-desktop">{{"Resource" | translate}}/{{"Contracts" | translate}}</th>
                        <!-- {{"AssociatesList.ContractTerm" | translate}} -->
                    </tr>
                    <tr class="tbl_head">
                        <!-- <th pSortableColumn="code" style="width:20%">
                            <div class="flex items-center gap-2">
                                {{"AssociatesList.REGULAR" | translate}}
                                <p-sortIcon field="code" />
                            </div>
                        </th> -->
                        <th>{{"AssociatesList.REGULAR" | translate}}</th>
                        <th>{{"AssociatesList.OVERTIME" | translate}}</th>
                        <th>{{"AssociatesList.MIDNIGHT" | translate}}</th>
                        <th>{{"AssociatesList.TOTAL" | translate}}</th>
                        <th>{{"AssociatesList.NOTSUBMIT" | translate}}</th>
                        <th>{{"AssociatesList.SUBMIT" | translate}}</th>
                        <th>{{"AssociatesList.REJECT" | translate}}</th>
                        <th>{{"AssociatesList.APPROVE" | translate}}</th>
                        <th>{{"AssociatesList.home" | translate}}</th>
                        <th>{{"AssociatesList.Absence" | translate}}</th>
                        <th>{{"AssociatesList.PaidHoliday" | translate}}</th>
                        <!-- <th>{{"AssociatesList.ContractTerm" | translate}}</th> -->
                    </tr>
                <!-- </thead>     -->
            </ng-template>
            <ng-template pTemplate="body" let-item>
                <tr class="tbl_cont">
                    <td [attr.rowspan]="item.timesheetSummaryCompanySectionGroupDto.length"><a href="javascript:void(0)" class="dlt_link" (click)="onCmpSearch(item.customerID)">{{item.customerName}}</a></td>
                    <td>{{item.timesheetSummaryCompanySectionGroupDto[0].section}}</td>
                    <td>{{item.timesheetSummaryCompanySectionGroupDto[0].regular}}</td>
                    <td>{{item.timesheetSummaryCompanySectionGroupDto[0].overtime}}</td>
                    <td>{{item.timesheetSummaryCompanySectionGroupDto[0].midnightOvertime}}</td>
                    <td>{{item.timesheetSummaryCompanySectionGroupDto[0].total}}</td>
                    <td>{{item.timesheetSummaryCompanySectionGroupDto[0].notSubmit}}</td>
                    <td>{{item.timesheetSummaryCompanySectionGroupDto[0].submit}}</td>
                    <td>{{item.timesheetSummaryCompanySectionGroupDto[0].reject}}</td>
                    <td>{{item.timesheetSummaryCompanySectionGroupDto[0].approve}}</td>
                    <td>{{item.timesheetSummaryCompanySectionGroupDto[0].teleWork}}</td>
                    <td>{{item.timesheetSummaryCompanySectionGroupDto[0].absence}}</td>
                    <td>{{item.timesheetSummaryCompanySectionGroupDto[0].paidHoliday}}</td>
                    <td>{{item.timesheetSummaryCompanySectionGroupDto[0].userCount}}/{{item.timesheetSummaryCompanySectionGroupDto[0].contractCount}}</td>
                </tr>
                
                <tr class="tbl_cont" *ngFor="let subItem of item.timesheetSummaryCompanySectionGroupDto.slice(1)">                    
                    <td>{{subItem.section}}</td>
                    <td>{{subItem.regular}}</td>
                    <td>{{subItem.overtime}}</td>
                    <td>{{subItem.midnightOvertime}}</td>
                    <td>{{subItem.total}}</td>
                    <td>{{subItem.notSubmit}}</td>
                    <td>{{subItem.submit}}</td>
                    <td>{{subItem.reject}}</td>
                    <td>{{subItem.approve}}</td>
                    <td>{{subItem.teleWork}}</td>
                    <td>{{subItem.absence}}</td>
                    <td>{{subItem.paidHoliday}}</td>
                    <td>{{subItem.userCount}}/{{subItem.contractCount}}</td>
                </tr>
            </ng-template>
            <ng-template pTemplate="footer">
                <tr class="tbl_fot">
                    <td colspan="2">{{"TOTAL" | translate}}</td>
                        <td>{{ totalRegular }}</td>  <!-- Regular total -->
						<td>{{ totalOverTime }}</td>  <!-- Overtime total -->
						<td>{{ totalMn }}</td>  <!-- Midnight total -->
						<td>{{ overAllTotal }}</td>  <!-- Overall total -->
						<td>{{ totalNotSubmit }}</td>  <!-- Not Submit -->
						<td>{{totalSubmit}}</td>  <!-- Submit -->
						<td>{{totalReject}}</td>  <!-- Reject -->
						<td>{{totalApprove}}</td>  <!-- Approve -->
						<td>{{totalHome}}</td>  <!-- Home -->
						<td>{{totalAbsence}}</td>  <!-- Absence -->
						<td>{{totalPh}}</td>  <!-- Paid Holiday -->
						<td>{{totalResource}}/{{totalContract}}</td>
                </tr>
                </ng-template>
            
        </p-table>
         
        <p-table 
        #dt2
        [value]="associatesList" [tableStyle]="{'width':'100%'}" 
        [paginator]="true"
        [rows]="10"
        [showCurrentPageReport]="true"
        [globalFilterFields]="['searchText']"        
        currentPageReportTemplate="{{'Showing' |translate}} {first} {{'to' | translate}} {last} {{'of' | translate}} {totalRecords} {{'entries' | translate}}"
        (onFilter)="onFilter($event)"
        (onPage)="onPage($event)" *ngIf="displayByCompany">
        <!-- <table class="display nowrap table table-striped" style="width:100%"> -->
            <ng-template #caption>
                
                <p-iconfield iconPosition="left" class="ml-auto">                        
                    <label>{{"SearchByText" | translate}}:</label>
                    <input pInputText type="text" (input)="onGlobalFilter($event)" placeholder="{{'SearchKey' | translate}}" />
                </p-iconfield>
                
            </ng-template>
            <ng-template pTemplate="header">                
                <!-- <thead> -->
                    <tr class="tbl_head">
                        <th rowspan="2" class="bor_lft_none">{{"AssociatesList.Section" | translate}}</th>
                        <th rowspan="2">{{"AssociatesList.Name" | translate}}</th>
                        <th colspan="4">{{"AssociatesList.TWH" | translate}}</th>
                        <th colspan="4">{{"AssociatesList.STATUS" | translate}}</th>
                        <th colspan="3">{{"AssociatesList.Summary" | translate}}</th>
                        <th rowspan="2" class="min-desktop">{{"AssociatesList.ContractTerm" | translate}}</th>
                        <th rowspan="2" class="min-desktop">{{"Download" | translate}}</th>
                    </tr>
                    <tr class="tbl_head">                        
                        <th>{{"AssociatesList.REGULAR" | translate}}</th>
                        <th>{{"AssociatesList.OVERTIME" | translate}}</th>
                        <th>{{"AssociatesList.MIDNIGHT" | translate}}</th>
                        <th>{{"AssociatesList.TOTAL" | translate}}</th>
                        <th>{{"AssociatesList.NOTSUBMIT" | translate}}</th>
                        <th>{{"AssociatesList.SUBMIT" | translate}}</th>
                        <th>{{"AssociatesList.REJECT" | translate}}</th>
                        <th>{{"AssociatesList.APPROVE" | translate}}</th>
                        <th>{{"AssociatesList.home" | translate}}</th>
                        <th>{{"AssociatesList.Absence" | translate}}</th>
                        <th>{{"AssociatesList.PaidHoliday" | translate}}</th>
                        <!-- <th>{{"AssociatesList.ContractTerm" | translate}}</th> -->
                    </tr>
                <!-- </thead>     -->
            </ng-template>
            <ng-template pTemplate="body" let-item>
                <tr class="tbl_cont">
                    <td [attr.rowspan]="item.timesheetSummary.length">{{item.sectionName}}</td>
                    <td><a href="manager-timesheet/{{item.timesheetSummary[0].timesheetId}}/{{item.timesheetSummary[0].userid}}" class="dlt_link">{{item.timesheetSummary[0].section}} </a></td>
                    <td>{{item.timesheetSummary[0].regular}}</td>
                    <td>{{item.timesheetSummary[0].overtime}}</td>
                    <td>{{item.timesheetSummary[0].midnightOvertime}}</td>
                    <td>{{item.timesheetSummary[0].total}}</td>
                    <td>{{item.timesheetSummary[0].notSubmit}}</td>
                    <td>{{item.timesheetSummary[0].submit}}</td>
                    <td>{{item.timesheetSummary[0].reject}}</td>
                    <td>{{item.timesheetSummary[0].approve}}</td>
                    <td>{{item.timesheetSummary[0].teleWork}}</td>
                    <td>{{item.timesheetSummary[0].absence}}</td>
                    <td>{{item.timesheetSummary[0].paidHoliday}}</td>
                    <td>{{item.timesheetSummary[0].contractTerm }}</td>
                    <td>
                        <button class="btn btn-primary btn-sm" (click)="createSingleAll(item.timesheetSummary[0].userIdOrg, item.timesheetSummary[0].section)"><i class="bi bi-download"></i></button>
                    </td>
                </tr>
                <!-- remaining child elements (no rowspan cell) -->
                <tr class="tbl_cont" *ngFor="let subItem of item.timesheetSummary.slice(1)">
                    <td>
                    <a href="manager-timesheet/{{ subItem.timesheetId }}/{{subItem.userid}}" class="dlt_link">
                        {{ subItem.section }}
                    </a>
                    </td>
                    <td>{{ subItem.regular }}</td>
                    <td>{{ subItem.overtime }}</td>
                    <td>{{ subItem.midnightOvertime }}</td>
                    <td>{{ subItem.total }}</td>
                    <td>{{ subItem.notSubmit }}</td>
                    <td>{{ subItem.submit }}</td>
                    <td>{{ subItem.reject }}</td>
                    <td>{{ subItem.approve }}</td>
                    <td>{{ subItem.teleWork }}</td>
                    <td>{{ subItem.absence }}</td>
                    <td>{{ subItem.paidHoliday }}</td>
                    <td>{{ subItem.contractTerm}}</td>
                    <td>
                        <button class="btn btn-primary btn-sm" (click)="createSingleAll(subItem.userIdOrg, subItem.section)"><i class="bi bi-download"></i></button>
                    </td>
                </tr>
                
            </ng-template>
            <ng-template pTemplate="footer">
                <tr class="tbl_fot">
                    <td colspan="2">{{"TOTAL" | translate}}</td>
                        <td>{{ totalRegularSection }}</td>  <!-- Regular total -->
                        <td>{{ totalOverTimeSection }}</td>  <!-- Overtime total -->
                        <td>{{ totalMnSection }}</td>  <!-- Midnight total -->
                        <td>{{ overAllTotalSection }}</td>  <!-- Overall total -->
                        <td>{{ totalNotSubmitSection }}</td>  <!-- Not Submit -->
                        <td>{{totalSubmitSection}}</td>  <!-- Submit -->
                        <td>{{totalRejectSection}}</td>  <!-- Reject -->
                        <td>{{totalApproveSection}}</td>  <!-- Approve -->
                        <td>{{totalHomeSection}}</td>  <!-- Home -->
                        <td>{{totalAbsenceSection}}</td>  <!-- Absence -->
                        <td>{{totalPhSection}}</td>  <!-- Paid Holiday -->
                        <td>&nbsp;</td>
                        <td><button class="btn btn-primary btn-sm" (click)="createSingleAll('-1', 'All')"><i class="bi bi-box-arrow-in-down"></i> {{"All" | translate}}</button></td>
                </tr>
            </ng-template>
        </p-table>
	
	<!--  ############### Data Table End ################# -->
	
</div>
<!--  ############### Middle Containt Area End ################# -->
